import { QuantityDto } from '../services/APIs/InternalAPI/internal-api.contracts'

export const MultiplyQuantity = (
  quantity: QuantityDto,
  multiplicant: number
) => {
  return quantity && { ...quantity, value: quantity.value * multiplicant }
}
